import React, { useMemo } from 'react'
import { useFormConfigContext } from './hooks/useFormConfig'
import { stripTabKeyFromOptions } from 'src/utils/era-package/tab-utils'
import { Typography } from '@mui/material'


const ErrorComponent = ({ error }) => {
  if (!!error)
    return <Typography color='error' variant='body2'>{error}</Typography>
  return <></>
}
export const RenderArrayField = ({ section, tabKey, optionsMap, readOnly, data: dataProp }) => {
  const formCtx = useFormConfigContext() || null

  const tableData = useMemo(() => {
    if (Array.isArray(section.data)) return section.data       // primary source
    if (Array.isArray(dataProp)) return dataProp         // alt prop if passed directly
    if (formCtx) return formCtx.getValues(section.name) || [] // RHF fallback
    return section.tableData || []     // legacy fallback
  }, [section.data, dataProp, formCtx, section.name, section.tableData])

  const handleInput = (next) => {
    // Keep RHF in sync when edits happen inside the table
    if (formCtx) {
      formCtx.setValue(section.name, next, { shouldValidate: true, shouldDirty: true })
    }
    // Emit to any external handler if needed

    if (typeof section.onTableDataChange === 'function') {
      section.onTableDataChange(next)
    }
  }

  const TableComponent = section.tableComponent

  return (
    <>
      <TableComponent
        title={section.title}
        fields={section.tableFields}
        formFields={section.formFields}
        name={section.name}
        editMode={section.editMode || 'none'}
        draggable={section.draggable}
        error={<ErrorComponent error={formCtx?.getError(section.name)} />}
        optionsMap={stripTabKeyFromOptions(optionsMap, tabKey)}
        data={tableData}
        tabKey={tabKey}
        onDataChange={handleInput}
        maxRows={section.maxRows}
        onUploadSuccess={section.onUploadSuccess}
        handleApiCall={section.handleApiCall}
        handleRefresh={section.handleRefresh}
        handleClearAll={section.handleClearAll}
        filesUnderProcessing={section.filesUnderProcessing}
        handleDeleteRow={section.handleDeleteRow}
        handleCloneRow={section.handleCloneRow}
        disableEdit={section.disableEdit || readOnly}
        disableAdd={section.disableAdd || readOnly}
        onRowClick={section.onRowClick}
        uploadFormComponent={section.uploadFormComponent}
        onUpload={section.onUpload}
        allowDownload={section.allowDownload}
        handleDownload={section.handleDownload}
        useESLineEdit={section.useESLineEdit}
        columns={section.columns}
        customColumn={section.customColumn}
        handleCalculate={section.handleCalculate}
        handleCalculateAllDuty={section.handleCalculateAllDuty}
        enableCalculate={section.enableCalculate}
        enableUpload={section.enableUpload}
        handleCustomEdit={section.handleCustomEdit}
        enableDelete={section.enableDelete}
        showHtsLookup={section.showHtsLookup}
        htsRowClick={section.htsRowClick}
      />
    </>
  )
}